import $ from 'jquery';

if ( $( '.accordion' ).length ) {
  $( '.accordion .title' ).on( 'click', function( e ) {
    e.preventDefault();

    var $this = $( this );
    var $accordion = $this.parent();
    var $content = $this.next();

    var $serviceText = $accordion.find(".category-text p");
    var $serviceButton = $accordion.find(".content  a");
    var $serviceItemWrapper = $accordion.find(".service-item-wrapper");

    $accordion.parent().find( '.content' ).css( 'height', '0' );

    if ( $accordion.hasClass( 'open' ) ) {
      $accordion.removeClass( 'open' );
    } else {      
      $accordion.siblings().removeClass( 'open' );
      $accordion.addClass( 'open' );
      $content.css( 'height', $content[0].scrollHeight + 64 );
    }

    if ($serviceItemWrapper.hasClass("animate-me")) {
      $serviceItemWrapper.removeClass("animate-me");
      $serviceText.removeClass("animate-me");
      $serviceButton.removeClass("animate-me");
    } else {
      $(".animate-me").removeClass("animate-me");
      $serviceItemWrapper.addClass("animate-me");
      $serviceText.addClass("animate-me");
      $serviceButton.addClass("animate-me");
    }
  });
}